import { render } from "./authenticated-with-navigation.view.vue?vue&type=template&id=97a8be7c&scoped=true&ts=true"
import script from "./authenticated-with-navigation.view.vue?vue&type=script&lang=ts"
export * from "./authenticated-with-navigation.view.vue?vue&type=script&lang=ts"

import "./authenticated-with-navigation.view.vue?vue&type=style&index=0&id=97a8be7c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97a8be7c"]])

export default __exports__